<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window" v-if="!team_switch">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <h5>来自{{ player_data.nickName }}的分享</h5>
                    <div class="msg-view">
                        <div class="text">【{{ player_data.nickName }}】邀请你进行参与本次阿斗赶集，是否接受？</div> 
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="team_switch = true;"></div>                                                                 
                    </div>
                   
                </div>
            </div>            
        </div>

        <div class="apply-modal u-window" v-if="team_switch">
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <h5 class="t-apply"></h5>
                    <div class="msg-view">
                        <div class="text">确认加入【{{ player_data.nickName }}】的绑定邀请？接受后无法更换，请谨慎选择！</div> 
                    </div>

                    <div class="u-ctrl">
                        <!-- <div class="u-btn cancel" @click="destroyElement ()"></div>   -->
                        <div class="u-btn ok" @click="apply"></div>                                                                                        
                    </div>
                   
                </div>
            </div>   
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.apply-modal{
    position: relative;
    width: 625px;
    height: 265px;
    background-image: url(~@/assets/images/modal/bg-modal-mgs.png);   
}

.t-apply{
    width: 516px;
    height: 52px;
    margin: 0 auto 0;
    background-image: url(~@/assets/images/modal/title-apply_invite.png);      
}

h5{
    text-align: center;
    font-size: 28px;
    color: #696560;
    font-weight: 400;
}

.msg-view{
    text-align: center;
    margin: 10px auto 0;
    padding: 0 50px;

    color: #725132;
    line-height: 1.8;
    text-align: center;

    b{
        padding: 0 10px;
        color: #d16443;
    }
}

.warn{
    font-size: 20px;
    text-align: center;
    color: #725132;
}

.u-ctrl{
    position: absolute;
    width: 100%;
    left: 50%;
    bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 0 40px;
}

.u-btn.ok{
    width: 186px;
    height: 56px;
    background-image: url(~@/assets/images/modal/btn-submit.png);    
}

</style>

<script>
export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码    
        }
    },
    created (){
        this.render();
        document.body.style.overflow = 'hidden';
    },  
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },
        render() {
            var _this = this;
            this.$axios.get(ajax_url_map.invite_info,{
                params : {
                    code : this.code,
                }
            })
            .then(res => {
                this.ready = true;
                this.error = false;
                this.player_data = res.data;
            },rej => {
                let error =  rej.message;
                this.text = error;
                this.error = true;
                this.ready = true;

                localStorage.setItem('share', '');                        
            });
        },
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            this.$axios.post(ajax_url_map.w12_invite_apply ,{
                code : this.code,
            })
            .then(
                res => {
                    this.destroyElement();
                    this.$success_apply();
                    localStorage.setItem('share', '');
                },
                rej => {
                    this.destroyElement();
                    let error = rej.code == 404 ? '该用户累计加入次数已达上限' : rej.message;
                    this.$msg_modal(error);

                    localStorage.setItem('share', '');                   
                }
            );
        },                
    },
}
</script>